import { PlusOutlined } from "@ant-design/icons";
import {
  StyledFlex,
  StyledGridCol,
  StyledGridRow,
  StyledSectionHeading,
  StyledSubTableContainer,
} from "@/common/styles";
import Button from "@/common/elements/Button";
import Table from "@/common/elements/Table";
import CommonDatePicker from "@/common/elements/DatePicker";
import Select from "@/common/elements/InputElements/Select";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import { useEffect, useState } from "react";
import TextField from "@/common/elements/InputElements/TextField";
import { Form } from "antd";
import {
  getOptionsFromRefList,
  hasCheckSecurity,
} from "@/util/common_function";
import dayjs from "dayjs";
import Modal from "@/common/elements/Modal";
import { v4 as uuidv4 } from "uuid";
import useDialog from "@/hooks/useDialog";
import Alert from "@/common/elements/Alerts";
import { Entity_types, Security_Types } from "@/util/permission_bits";
import { LABELS_CAPITAL } from "@/util/usePermissionMask";
import {
  MODULES_LIST_WITH_ID,
  SUB_MODULES_LIST_WITH_ID,
} from "@/util/common_variable";
import { useSelector } from "react-redux";

const InmateMedicationLogDetail = ({
  medicationData,
  medicationName,
  numOfBottle,
  updateLogData,
}) => {
  const currentUser = JSON.parse(localStorage.getItem("userDetails"));
    const { bookings, bookingsFieldsEnabled } = useSelector((state) => state?.bookings);

  const headers = [
    { key: "dateDispensed", text: "Date Dispensed" },
    { key: "timeDispensed", text: "Time Dispensed" },
    { key: "numberofPills", text: "# Pills" },
    { key: "stafLbl", text: "Staff Description" },
    { key: "comments", text: "Comments" },
  ];
  const [medicationLogForm] = Form.useForm();
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [isMedicationLogModal, setIsMedicationLogModal] = useState(false);
  const [medicationLog, setMedicationLog] = useState([]);
  const [barCodeStatusText, setBarCodeStatusText] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const { showDialog } = useDialog();

  const handleModalVisible = (val) => {
    setIsMedicationLogModal(!isMedicationLogModal);
    if (val == "edit") {
      setIsEdit(true);
    }
  };
  const handleAdd = () => {
    medicationLogForm.setFieldsValue({
      medicationID: null,
      medicationBarCode: null,
      inmateBar: null,
      dateTimeDispensed: dayjs(new Date()),
      creatorStaffID: null,
      dispensedByStaffID: currentUser?.staffId,
      numberofPills: null,
      comments: null,
      pinNo: bookings?.bookingId,
      dateTimeAdded: dayjs(new Date()),
      user: currentUser?.username,
    });
    setSelectedRowId(null);
    handleModalVisible();
  };

  useEffect(() => {
    setMedicationLog(medicationData?.medicationLog || []);
  }, [medicationData]);

  useEffect(() => {
    updateLogData(medicationLog);
  }, [medicationLog]);

  useEffect(() => {
    onCheckBarCodeStatus();
  }, [isMedicationLogModal]);

  const patchSelectedData = (data) => {
    medicationLogForm.setFieldsValue({
      ...data,
      inmateBar: data?.medicationBarCode,
      medicationID: medicationName,
      dateTimeDispensed: data.dateDispensed
        ? dayjs(`${data.dateDispensed} ${data.timeDispensed}`)
        : null,
      dateTimeAdded: data.dateAdded
        ? dayjs(`${data.dateAdded} ${data.timeAdded}`)
        : null,
    });
    setSelectedRowId(data.medicationLogID || data.id);
  };

  const saveMedicationLog = () => {
    medicationLogForm
      .validateFields()
      .then((values) => {
        (values.dateDispensed = values?.dateTimeDispensed
          ? dayjs(values?.dateTimeDispensed).format("MM/DD/YYYY")
          : null),
          (values.timeDispensed = values?.dateTimeDispensed
            ? dayjs(values?.dateTimeDispensed).format("HH:mm")
            : null);
        (values.dateAdded = values?.dateTimeAdded
          ? dayjs(values?.dateTimeAdded).format("MM/DD/YYYY")
          : null),
          (values.timeAdded = values?.dateTimeAdded
            ? dayjs(values?.dateTimeAdded).format("HH:mm")
            : null);

        delete values.dateTimeAdded;
        delete values.dateTimeDispensed;
        delete values.inmateBar;
        if (selectedRowId) {
          setMedicationLog((prev) =>
            prev?.map((p) =>
              p?.medicationLogID === selectedRowId || p?.id === selectedRowId
                ? {
                    ...values,
                    medicationLogID: selectedRowId,
                    numberofPills: parseInt(values?.numberofPills || 0),
                    medicationBarCode: parseInt(values?.medicationBarCode || 0),
                    pinNo: parseInt(values?.pinNo || 0),
                    medicationID: parseInt(values?.medicationID || 0),
                  }
                : p
            )
          );
        } else {
          setMedicationLog((prev) => [
            ...prev,
            {
              ...values,
              id: uuidv4(),
              numberofPills: parseInt(values?.numberofPills || 0),
              medicationBarCode: parseInt(values?.medicationBarCode || 0),
              pinNo: parseInt(values?.pinNo || 0),
              medicationID: parseInt(values?.medicationID || 0),
            },
          ]);
        }
        handleModalVisible();
      })
      .catch((err) => console.log(err));
  };
  const saveConfirmation = () => {
    const balanceBottle =
      numOfBottle -
        parseInt(medicationLogForm.getFieldValue("numberofPills")) || 0;
    showDialog("info", {
      title: "Warning",
      content:
        "Setting the current number of pills in the bottle/packet to " +
        (balanceBottle > 0 ? balanceBottle : 0),
      confirmButtonText: "Ok",
      onConfirm: saveMedicationLog,
    });
  };
  const handleBarCodeOnChange = (item) => {
    onCheckBarCodeStatus();
  };

  const onCheckBarCodeStatus = () => {
    const inmateBar = Number(medicationLogForm.getFieldValue("inmateBar"));

    const medicationBarCode = Number(
      medicationLogForm.getFieldValue("medicationBarCode")
    );

    if (
      inmateBar !== "" &&
      medicationBarCode !== "" &&
      inmateBar !== 0 &&
      medicationBarCode !== 0 &&
      !isNaN(Number(inmateBar)) &&
      !isNaN(Number(medicationBarCode))
    ) {
      if (Number(inmateBar) === Number(medicationBarCode)) {
        setBarCodeStatusText("MATCH");
      }
      if (Number(inmateBar) !== Number(medicationBarCode)) {
        setBarCodeStatusText("NO MATCH");
      }
    } else {
      setBarCodeStatusText("");
    }
  };
  useEffect(() => {
    if (isEdit) {
      let isShow = hasCheckSecurity(
        Security_Types.functionality,
        Entity_types.subModule,
        LABELS_CAPITAL.MODIFY,
        MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
        SUB_MODULES_LIST_WITH_ID.Inmate_Medical
      );
      if (isShow) {
        setIsDisabled(false);
      } else {
        setIsDisabled(true);
      }
    } else {
      setIsDisabled(false);
    }
  }, [isEdit]);
  return (
    <>
      <StyledSectionHeading>
        <span>Medication Log</span>
      </StyledSectionHeading>

      <StyledSubTableContainer>
        <StyledFlex justify="end" marginBottom="10px" gap="10px">
          <Button
            icon={<PlusOutlined />}
            onClick={handleAdd}
            disabled={
              !bookingsFieldsEnabled ||
              !hasCheckSecurity(
                Security_Types.functionality,
                Entity_types.subModule,
                LABELS_CAPITAL.ADD,
                MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                SUB_MODULES_LIST_WITH_ID.Inmate_Medical
              )
            }
          >
            Add
          </Button>
          <Button
            onClick={handleModalVisible}
            disabled={
              !selectedRowId || 
              !hasCheckSecurity(
                Security_Types.functionality,
                Entity_types.subModule,
                LABELS_CAPITAL.VIEW,
                MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                SUB_MODULES_LIST_WITH_ID.Inmate_Medical
              )
            }
          >
            Details
          </Button>
        </StyledFlex>

        {hasCheckSecurity(
          Security_Types.functionality,
          Entity_types.subModule,
          LABELS_CAPITAL.VIEW,
          MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
          SUB_MODULES_LIST_WITH_ID.Inmate_Medical
        ) && (
          <Table
            headers={headers}
            data={medicationLog.map((item) => {
              return {
                ...item,
                stafLbl: getOptionsFromRefList("", true)?.filter(
                  (data) => data.value === item.dispensedByStaffID
                )?.[0]?.label,
              };
            })}
            onRowClick={patchSelectedData}
            onRowDoubleClick={(data) => {
              patchSelectedData(data);
              handleModalVisible();
            }}
            // variant="outlined"
          ></Table>
        )}
      </StyledSubTableContainer>

      <Modal
        header={"Medication Log"}
        show={isMedicationLogModal}
        size="lg"
        onHide={handleModalVisible}
        footerActions={[
          {
            key: "save",
            text: "Save",
            onClick: saveConfirmation,
            disabled: isDisabled || !bookingsFieldsEnabled,
          },
        ]}
        footerCloseAction={() => setIsEdit(false)}
        footerCloseActionText={"Close"}
      >
        <Form form={medicationLogForm}>
          <StyledSectionHeading>
            <span>Medication Information</span>
          </StyledSectionHeading>

          <StyledGridRow gutter={16}>
            <StyledGridCol lg={5}>
              <FormItem label="Medication" disabled name="medicationID">
                <TextField disabled placeholder={medicationName} />
              </FormItem>
            </StyledGridCol>

            <StyledGridCol lg={6}>
              <FormItem label="Inmate Bar Code" name="inmateBar">
                <TextField type={"number"} onChange={handleBarCodeOnChange} disabled={!bookingsFieldsEnabled} />
              </FormItem>
            </StyledGridCol>

            <StyledGridCol lg={6}>
              <FormItem
                label="Medication Bar Code"
                name="medicationBarCode"
                dependencies={["inmateBar"]}
                hasFeedback
                rules={[
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (getFieldValue("inmateBar") == value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error("Code is Mismatching"));
                    },
                  }),
                ]}
              >
                <TextField type={"number"} onChange={handleBarCodeOnChange} disabled={!bookingsFieldsEnabled}/>
              </FormItem>
            </StyledGridCol>

            <StyledGridCol lg={5}>
              <Alert
                style={{ marginTop: "24px" }}
                type={barCodeStatusText === "MATCH" ? "success" : "error"}
                show={barCodeStatusText && barCodeStatusText !== ""}
                message={
                  <div style={{ textAlign: "center" }}>
                    <b>{barCodeStatusText}</b>
                  </div>
                }
                isDismissible={false}
              />
            </StyledGridCol>
          </StyledGridRow>

          <StyledSectionHeading>
            <span>Dispensation Information</span>
          </StyledSectionHeading>

          <StyledGridRow gutter={16}>
            <StyledGridCol>
              <FormItem label="Date & Time Dispensed" name="dateTimeDispensed">
                <CommonDatePicker showTime={true} format={"MM/DD/YYYY HH:mm"} disabled={!bookingsFieldsEnabled} />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol lg={6}>
              <FormItem label="Dispensing Officer" name="dispensedByStaffID">
                <Select
                  options={getOptionsFromRefList("", true)}
                  placeholder="Dispensing Officer"
                  showSearch={true}
                  variant="outlined"
                  disabled={!bookingsFieldsEnabled}
                  // onChange={(e) => {
                  //     setTimeout(() => document.activeElement.blur(), 0)
                  // }}
                />
              </FormItem>
            </StyledGridCol>

            <StyledGridCol lg={6}>
              <FormItem
                label="# Pills"
                name="numberofPills"
                rules={[
                  {
                    required: true,
                    message: "# Pills is required",
                  },
                ]}
              >
                <TextField type={"number"} disabled={!bookingsFieldsEnabled} />
              </FormItem>
            </StyledGridCol>

            <StyledGridCol lg={24}>
              <FormItem label="Comments" name="comments">
                <TextField inputType="textarea" disabled={!bookingsFieldsEnabled} />
              </FormItem>
            </StyledGridCol>
          </StyledGridRow>

          <StyledSectionHeading>
            <span>Administrative Information</span>
          </StyledSectionHeading>

          <StyledGridRow gutter={16}>
            <StyledGridCol lg={4}>
              <FormItem label="ID" name="pinNo">
                <TextField type={"number"} disabled={!bookingsFieldsEnabled}/>
              </FormItem>
            </StyledGridCol>

            <StyledGridCol lg={6}>
              <FormItem label="Date & Time Entered" name="dateTimeAdded">
                <CommonDatePicker showTime={true} format={"MM/DD/YYYY HH:mm"} disabled={!bookingsFieldsEnabled} />
              </FormItem>
            </StyledGridCol>

            <StyledGridCol lg={8}>
              <FormItem label="User" name="user">
                <TextField disabled={!bookingsFieldsEnabled} />
              </FormItem>
            </StyledGridCol>
          </StyledGridRow>
        </Form>
      </Modal>
    </>
  );
};
export default InmateMedicationLogDetail;
